import tooltipTemplate from '../templates/tooltipquestionmark.hbs';

class ToolTipWidget extends HTMLElement {
    constructor(){
        super();
        this.href = this.getAttribute('href');
        this.render();
    }

    connectedCallback(){
        this.addEventListener('click', this.openURL);
        this.addEventListener('mouseover', this.setURLandShowToolTip);
        this.addEventListener('mouseout', this.hideToolTip);
    }

    render(){
        this.innerHTML = tooltipTemplate();
    }

    openURL = () =>  {
        if (this.hasAttribute('href') && this.getAttribute('href') !== '') {
            window.open(this.href, '_blank');
        }
    }

    setURLandShowToolTip = () => {
        if (this.hasAttribute('href') && this.getAttribute('href') !== '') {
            // show the tool tip
            const toolTipSpan = this.querySelector('.tool-tip-span');
            toolTipSpan.style.display = 'flex';
            toolTipSpan.style.position = 'absolute';
            toolTipSpan.style.width = '100px';
            toolTipSpan.style.color = 'white';
            toolTipSpan.style.top = '-30px';
            toolTipSpan.style.left = '50%';
            toolTipSpan.style.zIndex = '1';
            toolTipSpan.style.fontSize = '13px';
            toolTipSpan.style.backgroundColor = 'black';
            toolTipSpan.style.borderRadius = '6px';
            toolTipSpan.style.padding = '7px';
            toolTipSpan.style.display = 'flex';
        }
    }

    hideToolTip = () => {
        const toolTipSpan = this.querySelector('.tool-tip-span');
        toolTipSpan.style.display = 'none';
    }
}

customElements.define('sinclair-tooltipquestionmark', ToolTipWidget);
